import { Box, Flex, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { OrgPublicProfileDto } from "../../../../autogen/bff-api";
import { TipTap } from "../../../../common/input/TipTap/TipTap";

export const AboutUs = ({ organization }: { organization: OrgPublicProfileDto }) => {
  const { t } = useTranslation();
  return (
    <Flex
      border="1px solid"
      borderColor="smBorder"
      flexDirection="column"
      alignItems="start"
      justifyContent="start"
      borderRadius="lg"
      padding="25px"
      bg="smBackground"
      width="full"
      overflowX="auto"
      height="auto"
    >
      <Box>
        <Text fontSize={"md"} fontWeight="bold">
          {t("About us")}
        </Text>
      </Box>
      <Box>
        {organization.aboutUs ? (
          <TipTap content={organization.aboutUs} hasBorder={false} editable={false} padding="0" />
        ) : (
          <Text as="span" fontSize={"sm"} color="smMuted">
            <i>{t("Not provided")}.</i>
          </Text>
        )}
      </Box>
    </Flex>
  );
};
